module.exports = __webpack_public_path__ + "static/media/logo.ca7d04c0.png";